module.exports = __webpack_public_path__ + "static/media/27.47ddbb47.JPG";